import dedent from 'ts-dedent';
import { ColumnDataType, Provider, WorkflowComponentParamType } from '../types';
import { getDBTypesByProvider } from '../utils/index';
import { SelectWorkflowComponent } from './common/selectcomponent';
class RefactorColumns extends SelectWorkflowComponent {
    constructor() {
        super({
            name: 'native.refactorcolumns',
            group: 'Data Preparation',
            title: 'Edit Schema',
            description: `
      This component allows to change to names and data types of table columns.
      `,
            starred: true
        }, [
            {
                name: 'source',
                type: WorkflowComponentParamType.InputTable,
                title: 'Source table'
            },
            {
                name: 'columns',
                type: WorkflowComponentParamType.SelectColumnType,
                title: 'Column name and type',
                parent: 'source',
                noDefault: true,
                providers: [
                    Provider.BigQuery,
                    Provider.Snowflake,
                    Provider.Redshift,
                    Provider.Postgres
                ]
            },
            {
                name: 'databricks_columns',
                type: WorkflowComponentParamType.SelectColumnType,
                title: 'Column name and type',
                parent: 'source',
                noDefault: true,
                dataType: [
                    ColumnDataType.Number,
                    ColumnDataType.String,
                    ColumnDataType.Boolean,
                    ColumnDataType.Date,
                    ColumnDataType.Time,
                    ColumnDataType.Datetime,
                    ColumnDataType.Timestamp
                ],
                providers: [Provider.DatabricksRest]
            }
        ]);
    }
    getInnerSql({ params, connection }) {
        const columns = connection.type === Provider.DatabricksRest
            ? params.databricks_columns
            : params.columns;
        const lines = columns?.split('\n')?.map((x) => x.trim()) || [];
        const newCols = [];
        for (let line of lines) {
            const tokens = line.split(',').map((x) => x.trim());
            const type = tokens[2];
            if (connection.type === Provider.BigQuery) {
                newCols.push(`SAFE_CAST(${tokens[0]} AS ${type}) AS ${tokens[1]}`);
            }
            else if (connection.type === Provider.Snowflake &&
                type === 'GEOGRAPHY') {
                newCols.push(`TRY_TO_GEOGRAPHY(${tokens[0]}) AS ${tokens[1]}`);
            }
            else {
                newCols.push(`CAST(${tokens[0]} AS ${type}) AS ${tokens[1]}`);
            }
        }
        if (newCols.length === 0) {
            newCols.push('1');
        }
        if (connection.type === Provider.DatabricksRest) {
            return dedent `SELECT /*+ REPARTITION(40) */
                      ${newCols.join(',\n')}
                    FROM ${connection.quoteName(params.source)}`;
        }
        else {
            return dedent `SELECT
                      ${newCols.join(',\n')}
                    FROM ${connection.quoteName(params.source)}`;
        }
    }
    getUIProperties(provider) {
        return getDBTypesByProvider(provider);
    }
    getVersion(provider) {
        return '2';
    }
    canProvideOutputSchemas() {
        return true;
    }
    getOutputSchema({ params, connection }) {
        const schema = [];
        const columnsParam = connection.type === Provider.DatabricksRest
            ? params.databricks_columns
            : params.columns;
        const lines = columnsParam?.split('\n')?.map((x) => x.trim()) || [];
        for (let line of lines) {
            const tokens = line.split(',').map((x) => x.trim());
            const name = tokens[1];
            const db_type = tokens[2];
            const type = connection.dataProviderTypeToColumnType(db_type);
            schema.push({ name, type, db_type });
        }
        return schema;
    }
}
export { RefactorColumns };
